/**
 * @class SetShareStories
 * use jquery
 */
export default class SetShareStories {
  /**
   * constructor
   */
  constructor() {
    this.$fb = $('.opj-parts__share--facebook a');
    this.$tw = $('.opj-parts__share--twitter a');
    this.$line = $('.opj-parts__share--line a');

    this.setup();
  }

  /**
   * setup
   */
  setup() {
    let self = this;

    let shareURL = encodeURIComponent($("meta[property='og:url']").attr("content"));

    let shareTxt = encodeURIComponent($("meta[property='twitter:sharetext']").attr("content"));
    if(shareTxt == 'undefined') {
      shareTxt = encodeURIComponent($("meta[property='og:description']").attr("content"));
    }
    shareTxt = shareTxt.replace('%5Cn', '%0A');

    let shareHash = encodeURIComponent($("meta[property='twitter:sharehash']").attr("content"));
    if(shareHash == 'undefined') {
      shareHash = '';
    } else {
      shareHash = '&hashtags=' + shareHash;
    }

    let facebook = `http://www.facebook.com/share.php?u=${shareURL}`;
    let twitter = `https://twitter.com/share?text=${shareTxt}&url=${shareURL}${shareHash}`;
    let line = `https://line.me/R/msg/text/?${shareURL}`;

    this.$fb.attr("href", facebook);
    this.$tw.attr("href", twitter);
    this.$line.attr("href", line);
  }
}